<template>

    <v-dialog :value="userProfile" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
      <v-card class="ptest">
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ userProfileObj.first_name ? userProfileObj.first_name : '' }} Profile</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn 
            icon 
            depressed 
            dark 
            @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="elevation-0 ">
          <v-container>
            <v-layout row>
              <v-flex sm12 md6 class="px-3">
                <basic-info></basic-info>
              </v-flex>
              <v-flex sm12 md6 class="px-3">
                <security></security>
              </v-flex>
              <v-flex sm12 md6 class="px-3">
                <pin></pin>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-card>
    </v-dialog>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Security from './UsersProfile/Security';
import BasicInfo from './UsersProfile/BasicInfo';
import Pin from './UsersProfile/Pin';

export default {
  components: {
    Security,
    BasicInfo,
    Pin,
  },
  data() {
    return {

    };
  },
  created() {
    this.closeModal();
  },
  computed: {
    ...mapGetters({
      userProfile: 'user/userProfile',
      userProfileObj: 'user/userProfileObj',
    }),
  },
  
  methods: {
  
    closeModal() {
      this.setUserProfile(false);
      this.setUserProfileObj({});
    },
   
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      setUserProfileObj: 'user/setUserProfileObj',
      setUserProfile: 'user/setUserProfile',
    }),

  },
};
</script>
<style scoped>
.at-middle{
    position: relative;
    top: 50%;
    height: calc(100vh - 100px);
    display: flex;
}
</style>